import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {
  Alert,
  FormInput,
  FormInputText,
  FormInputCheckbox,
  DetailList,
  ButtonContainer,
  Button
} from 'camino-react'

import Modal from 'Components/Modal'

const CustomFilterForm = ({
  showModal,
  removeModal,
  filters,
  customFiltersFields,
  errors,
  message,
  updateCustomFilterFields,
  submit,
  savingStatus
}) => {
  const { name, shared } = customFiltersFields
  const customFilters = _.filter(filters, ({ value }) => value)

  return (
    <div>
      <Modal showModal={showModal} title="Save Custom Filters" removeModal={() => removeModal()}>

        { message && (
          <Alert type="error">
            {message}
          </Alert>
        )}

        <FormInput label="Name">
          <FormInputText
            value={name}
            onValue={value => updateCustomFilterFields('name', value)}
            errors={errors.name}
          />
        </FormInput>

        <div>
          <FormInputCheckbox
            onValue={value => updateCustomFilterFields('shared', value)}
            value={shared}
          >
              Shared
          </FormInputCheckbox>
        </div>

        <DetailList
          list={[{
            title: 'Filters',
            content: (
              <DetailList
                list={_.map(customFilters, (filter, index) => ({ content: `${filter.title || 'ID or Title'} is ${filter.type ? '' : 'like '}${filter.label || filter.value}` }))}
              />
            )
          }]}
        />

        <ButtonContainer center spaced>
          <Button onClick={() => removeModal()} outline>
          Cancel
          </Button>
          <Button onClick={() => submit()}>
            {savingStatus}
          </Button>
        </ButtonContainer>
      </Modal>
    </div>
  )
}

CustomFilterForm.propTypes = {
  showModal: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  savingStatus: PropTypes.string.isRequired,
  filters: PropTypes.arrayOf(PropTypes.object).isRequired,
  customFiltersFields: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    shared: PropTypes.bool
  }).isRequired,
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  submit: PropTypes.func.isRequired,
  removeModal: PropTypes.func.isRequired,
  updateCustomFilterFields: PropTypes.func.isRequired
}

export default CustomFilterForm
